import createSanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import * as queries from './queries';
const options = {
  dataset: 'production',
  projectId: '36ksfn55'
};
export const client = createSanityClient(options); // image builder
// Get a pre-configured url-builder from your sanity client

const builder = imageUrlBuilder(client); // Then we like to make a simple function like this that gives the
// builder an image and returns the builder for you to specify additional
// parameters:

export function urlFor(source) {
  return builder.image(source);
} // query by slug of page. varying slugs like credit-talks, other landing pages, etc

export async function getPage(slug) {
  const slugs = JSON.stringify([slug, `/${slug}`, slug.replace(/^\/+/, '')]);
  const query = `
	  {
	    "page": *[_type == "page" && slug.current in ${slugs}][0]{
	      "id": _id,
	      modules[]{
	        defined(_ref) => {
	          ...@->content[0]{
	            ${queries.modules}
	          }
	        },
	        !defined(_ref) => {
	          ${queries.modules}
	        }
	      },
	      title,
				headerLayout,
	      seo{
	        _type,
	        metaDesc,
	        metaTitle,
	        "metaImage": metaImage.asset->url
	      }
	    }
	  }
	`;
  const data = await client.fetch(query);
  return data;
}
export async function getLanderPage(slug) {
  const slugs = JSON.stringify([slug, `/${slug}`, slug.replace(/^\/+/, '')]);
  const query = `
		*[_type == "page" && slug.current in ${slugs}][0]{
			"id": _id,
			modules[]{
				defined(_ref) => {
					...@->content[0]{
						${queries.partnershipMods}
					}
				},
				!defined(_ref) => {
					${queries.partnershipMods}
				}
			},
			title,
			layout{
				_type,
				header{
					...,
					"partnershipLogo": partnershipLogo.asset->url
				},
				footer{
					...,
					styles{
						${queries.styles}
					}
				}
			},
			seo{
				_type,
				"description": metaDesc,
				"title": metaTitle,
				"image": metaImage.asset->url
			}
		}
  `;
  return await client.fetch(query);
} // query for vanity urls documents

export async function getVanityUrls() {
  const query = `{
    "vanityUrls": *[_type == "vanityUrl"]
  }`;
  const {
    vanityUrls
  } = await client.fetch(query);
  const redirects = [];
  vanityUrls.forEach(vanity => {
    const {
      slug,
      redirectUrl,
      utmSource,
      utmCampaign,
      utmMedium
    } = vanity;
    const utm = {
      campaign: utmCampaign ? `utm_campaign=${utmCampaign}` : '',
      source: utmSource ? `utm_source=${utmSource}` : '',
      medium: utmMedium ? `utm_medium=${utmMedium}` : ''
    };
    let toUrl = `${redirectUrl}`;
    let counter = 0; // counter for the first defined url param

    Object.keys(utm).forEach((key, index) => {
      if (utm[key]) {
        counter++;
        toUrl += `${counter === 1 ? '?' : '&'}${utm[key]}`;
      }
    });
    redirects.push({
      from: '^/' + slug.current + '$',
      to: toUrl
    });
  });
  return redirects;
}